<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <field-permission-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import FieldPermissionShowData from "./FieldPermissionShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "FieldPermissionShow",
        components: {CrudShow, FieldPermissionShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'surety.fieldPermission.showing',
            }
        },
    }
</script>

